<div
  class="size-full rounded-md border-4 p-4 transition-all"
  [class]="
    appearance() === 'DEFAULT'
      ? 'border-dashed border-white bg-white/30'
      : appearance() === 'CORRECT'
        ? 'border-solid border-emerald-500 bg-emerald-500/50'
        : 'border-solid border-red-500 bg-red-500/50'
  "
>
  <ng-content></ng-content>
</div>
